import React from "react";
import SearchProvider from "../SearchProvider";
import SearchResults from "../SearchResults";
import SearchForm from "../SearchForm";
import IBuildrProps from "../../../utilities/IBuildrProps";
import { AutomationPlacement } from "../../../utilities/automation";

export interface ISearcWidgetProps extends IBuildrProps {
    containerClass?: string;
    buttonClass?: string;
    lineColor?: string;
    inputPlaceholder?: string;
    inputClass?: string;
    pageType?: "blog" | "help" | "newsroom" | null;
    focus?: boolean;
    enableRedirects?: boolean;
    limit?: number;
    placement?: AutomationPlacement;
}

const Search = (props: ISearcWidgetProps) => {
    return (
        <SearchProvider>
            <SearchForm {...props} />
            <SearchResults />
        </SearchProvider>
    );
}

export default Search;